import { EventTracking } from "@shared/services/event_tracking/events";
import { updatePageIds } from "@shared/services/event_tracking/page_id_tracking";

const { trackEvent } = EventTracking;

var run = function ($rootScope, $location, $window, EventTracking, User, RetailerContext, C) {
  var logPageView = function (event, toState, toParams) {
    updatePageIds();
    trackEvent("page_view");
  };

  $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams) {
    logPageView(event, toState, toParams);
  });
};

run.$inject = ["$rootScope", "$location", "$window", "User", "RetailerContext", "C"];

tiz.run(run);
